import { Calendar, Wallet, Link as LinkIcon, Clock } from "lucide-react";
import { formatDate, exactDaysAtSanctuaryLabel } from "@/lib/dateUtils";

export default function SanctuaryInfoSection({ caseItem }) {
  if (caseItem.status !== "Sanctuary Resident") return null;
  const arrival = caseItem.arrival_at_sanctuary_date;

  return (
    <div className="bg-amtm-teal/10 border border-amtm-teal/30 rounded-2xl p-5 mb-6 space-y-2" data-testid="sanctuary-info-section">
      <h2 className="font-display text-lg text-amtm-teal mb-1">Sanctuary Life</h2>
      <p className="flex items-center gap-2 text-sm text-amtm-text">
        <Calendar className="h-4 w-4 text-amtm-teal shrink-0" /> Arrived {arrival ? formatDate(arrival) : "date unknown"}
      </p>
      <p className="flex items-center gap-2 text-sm text-amtm-text" data-testid="sanctuary-exact-days">
        <Clock className="h-4 w-4 text-amtm-teal shrink-0" /> {exactDaysAtSanctuaryLabel(arrival)}
      </p>
      {caseItem.monthly_care_cost > 0 && (
        <p className="flex items-center gap-2 text-sm text-amtm-text">
          <Wallet className="h-4 w-4 text-amtm-teal shrink-0" /> ₹{caseItem.monthly_care_cost.toLocaleString("en-IN")}/month care cost
        </p>
      )}
      {caseItem.sponsor_razorpay_link && (
        <p className="flex items-center gap-2 text-sm text-amtm-text">
          <LinkIcon className="h-4 w-4 text-amtm-teal shrink-0" />
          <a href={caseItem.sponsor_razorpay_link} target="_blank" rel="noopener noreferrer" className="underline" data-testid="sanctuary-sponsor-link">
            Sponsor link
          </a>
        </p>
      )}
    </div>
  );
}
